import { Subject, of, forkJoin, fromEvent } from 'rxjs';
import { catchError, filter, map, takeUntil, startWith, take } from 'rxjs/operators';
import { coerceBooleanProperty, coerceNumberProperty } from '@angular/cdk/coercion';
import { DOWN_ARROW, UP_ARROW } from '@angular/cdk/keycodes';
import { DecimalPipe, NgTemplateOutlet, CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { EventEmitter, HostListener, Input, Directive, Output, ChangeDetectionStrategy, Component, Injectable, input, ViewChildren, ContentChildren, ContentChild, ViewChild, Optional, Self, HostBinding, NgModule } from '@angular/core';
import { NxLabelComponent, NxErrorComponent, ERROR_DEFAULT_OPTIONS, NxErrorModule, NxLabelModule } from '@aposin/ng-aquila/base';
import * as i1 from '@aposin/ng-aquila/button';
import { NxButtonModule } from '@aposin/ng-aquila/button';
import * as i2 from '@aposin/ng-aquila/icon';
import { NxIconModule } from '@aposin/ng-aquila/icon';
import * as i1$1 from '@aposin/ng-aquila/spinner';
import { NxSpinnerModule } from '@aposin/ng-aquila/spinner';
import * as i1$2 from '@aposin/ng-aquila/utils';
import * as i3 from '@angular/forms';
import * as i4 from '@angular/cdk/a11y';
const _c0 = ["*"];
function NxFileUploaderItemName_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("background-color", ctx_r0.iconColor[ctx_r0.extension] || "#000");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.extension);
  }
}
function NxFileUploaderItemSize_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.uploadingLabel);
  }
}
function NxFileUploaderItemSize_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "number");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind2(2, 1, ctx_r0.size / 1024 / 1024, ".2"), " MB");
  }
}
function NxFileUploaderItemStatus_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "nx-spinner", 0);
  }
}
function NxFileUploaderItemStatus_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "nx-icon", 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵattribute("aria-label", ctx_r0.uploadedLabel || null);
  }
}
const _c1 = ["nativeInputFile"];
const _c2 = ["fileRowElement"];
const _c3 = [[["nx-label"]], [["", "nxFileUploadHint", ""]], "*", [["nx-file-uploader-drop-zone"]], [["", "nxFileUploadButton", ""]], [["nx-error"]]];
const _c4 = ["nx-label", "[nxFileUploadHint]", "*", "nx-file-uploader-drop-zone", "[nxFileUploadButton]", "nx-error"];
const _c5 = (a0, a1) => ({
  templateContext: a0,
  file: a1
});
function NxFileUploaderComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 5);
  }
}
function NxFileUploaderComponent_Conditional_8_For_2_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function NxFileUploaderComponent_Conditional_8_For_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6, 2);
    i0.ɵɵlistener("keydown", function NxFileUploaderComponent_Conditional_8_For_2_Template_div_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2._handleKeydownListRow($event));
    });
    i0.ɵɵtemplate(2, NxFileUploaderComponent_Conditional_8_For_2_ng_container_2_Template, 1, 0, "ng-container", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const file_r4 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    const defaultFileRow_r5 = i0.ɵɵreference(10);
    i0.ɵɵclassProp("nx-file-uploader--file-state-uploading", file_r4.isUploading)("nx-file-uploader--default-template", !ctx_r2._itemTemplate);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2._itemTemplate ? ctx_r2._itemTemplate : defaultFileRow_r5)("ngTemplateOutletContext", i0.ɵɵpureFunction2(6, _c5, ctx_r2._templateContext, file_r4));
  }
}
function NxFileUploaderComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵrepeaterCreate(1, NxFileUploaderComponent_Conditional_8_For_2_Template, 3, 9, "div", 5, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵattribute("aria-label", ctx_r2._templateContext.uploadedListLabel);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r2.value);
  }
}
function NxFileUploaderComponent_ng_template_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelement(0, "nx-file-upload-name", 8)(1, "nx-file-upload-size", 9);
    i0.ɵɵelementStart(2, "div", 10);
    i0.ɵɵelement(3, "nx-file-upload-status", 11);
    i0.ɵɵelementStart(4, "nx-file-upload-delete", 12);
    i0.ɵɵlistener("click", function NxFileUploaderComponent_ng_template_9_Template_nx_file_upload_delete_click_4_listener() {
      const file_r7 = i0.ɵɵrestoreView(_r6).file;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.removeFile(file_r7));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const templateContext_r8 = ctx.templateContext;
    const file_r7 = ctx.file;
    i0.ɵɵproperty("name", file_r7 == null ? null : file_r7.name);
    i0.ɵɵadvance();
    i0.ɵɵproperty("size", file_r7 == null ? null : file_r7.size)("isUploading", file_r7.isUploading)("uploadingLabel", templateContext_r8.uploadingLabel);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("isUploading", file_r7.isUploading)("isUploaded", file_r7.isUploaded)("uploadedLabel", templateContext_r8.uploadedLabel);
    i0.ɵɵadvance();
    i0.ɵɵproperty("deleteLabel", templateContext_r8.deleteLabel)("isUploading", file_r7.isUploading);
  }
}
class NxFileUploadSuccess {
  constructor(/** The files that were successfully uploaded. */
  files, /** The results of the request(s). */
  requests) {
    this.files = files;
    this.requests = requests;
  }
}
class NxFileUploadError {
  constructor(/** The files that had an error while uploading. */
  files, /** The returned errors of the request(s). */
  requests) {
    this.files = files;
    this.requests = requests;
  }
}
class NxFileUploader {
  /** Sets the config options for http requests for uploading the files. */
  set config(options) {
    if (this._config !== options) {
      this._config = options;
    }
  }
  get config() {
    return this._config;
  }
  constructor(config, http) {
    /** Stream that emits the result of an upload request. */
    this.response = new Subject();
    this._config = config;
    this._httpClient = http;
  }
  /** Uploads the files to the url specified in config. */
  uploadFiles(files) {
    if (this.config.uploadSeparately) {
      this._uploadFilesSeparately(files);
    } else {
      this._uploadFilesCollectively(files);
    }
  }
  /** Uploads all files with a POST request to the url specified in config. */
  _uploadFilesCollectively(files) {
    // get a list of all files; if there is no one: return
    if (!files || files.length === 0) {
      return;
    }
    const formData = new FormData();
    // save value here in case that it changes while request is running
    const valuesToUpload = files.filter(file => !file.isUploaded);
    valuesToUpload.forEach(file => {
      file.setUploadingState();
      formData.append('uploads[]', file.file, file.name);
    });
    this._httpClient.post(this.config.requestUrl, formData, this.config.options).subscribe(data => {
      valuesToUpload.forEach(file => file.setUploadedState());
      this.response.next({
        allSucessful: true,
        success: new NxFileUploadSuccess(valuesToUpload, [data])
      });
    }, error => {
      valuesToUpload.forEach(file => file.setErrorState());
      this.response.next({
        error: new NxFileUploadError(valuesToUpload, [error])
      });
    });
  }
  /**
   * Uploads all files with a POST request to the url specified in config.
   *
   * Each file is uploaded with an individual request.
   */
  _uploadFilesSeparately(files) {
    // get a list of all files; if there is no one: return
    if (!files) {
      return;
    }
    const responses = [];
    const filesToUpload = files.filter(file => !file.isUploaded);
    filesToUpload.forEach(file => {
      responses.push(this._uploadFile(file).pipe(catchError(error => of(error))));
    });
    forkJoin(responses).subscribe(results => {
      const mergedResults = results.reduce((acc, result) => {
        if (result.success) {
          if (!acc.success) {
            acc.success = new NxFileUploadSuccess([], []);
          }
          acc.success.files.push(...result.success.files);
          acc.success.requests.push(...result.success.requests);
        } else if (result.error) {
          if (!acc.error) {
            acc.error = new NxFileUploadError([], []);
          }
          acc.error.files.push(...result.error.files);
          acc.error.requests.push(...result.error.requests);
        }
        return acc;
      }, {});
      if (!mergedResults.error) {
        mergedResults.allSucessful = true;
      }
      this.response.next(mergedResults);
    });
  }
  /** Uploads one file with a POST request to the url specified in config. */
  _uploadFile(file) {
    const fileReturnVal = new Subject();
    const formData = new FormData();
    if (!file.isUploaded) {
      file.setUploadingState();
      formData.append('uploads[]', file.file, file.name);
    }
    this._httpClient.post(this.config.requestUrl, formData, this.config.options).subscribe(data => {
      file.setUploadedState();
      fileReturnVal.next({
        success: new NxFileUploadSuccess([file], [data])
      });
      fileReturnVal.complete();
    }, error => {
      file.setErrorState();
      fileReturnVal.next({
        error: new NxFileUploadError([file], [error])
      });
      fileReturnVal.complete();
    });
    return fileReturnVal;
  }
}

/**
 * Class used to keep track of the current states of the file.
 */
class FileItem {
  constructor(file, index = 0) {
    /** Whether the file is being uploaded at the moment. */
    this.isUploading = false;
    /** Whether the file was successfully uploaded. */
    this.isUploaded = false;
    /** Whether an error occured when uploading the file. */
    this.isError = false;
    /** Sets the index of the file. */
    this.index = 0;
    /**
     * Emits the FileItem on changed.
     */
    this.onChange = new EventEmitter();
    this.file = file;
    this.name = file.name;
    this._size = file.size;
    this._type = file.type;
    this.index = index;
  }
  /** Returns the file size in bytes */
  get size() {
    return this._size;
  }
  /** Returns the file type */
  get type() {
    return this._type;
  }
  /**
   * Sets the file to a uploaded state.
   */
  setUploadedState() {
    this.isUploaded = true;
    this.isUploading = false;
    this.isError = false;
    this.onChange.emit(this);
  }
  /**
   * Sets the file to a 'upload-in-progress' state.
   */
  setUploadingState() {
    this.isUploaded = false;
    this.isUploading = true;
    this.isError = false;
    this.onChange.emit(this);
  }
  /**
   * Sets the file to an error state.
   */
  setErrorState() {
    this.isUploaded = false;
    this.isUploading = false;
    this.isError = true;
    this.onChange.emit(this);
  }
}

/**
 * Verifies the file type against the accepted types.
 */
function isFileTypeValid(file, accept, strict) {
  if (!accept || !file.type && !strict) {
    return true;
  }
  const fileExtension = getFileExtension(file.name);
  return accept.replace(/\s/g, '').split(',').filter(acc => {
    const testExp = new RegExp(acc);
    return testExp.test(file.type) || acc === fileExtension;
  }).length > 0;
}
/**
 * Verifies the file size against the max file size allow.
 */
function isMaxFileSizeValid(file, maxFileSize) {
  return !maxFileSize || file.size <= maxFileSize;
}
/** Returns the file extension including the dot or empty string if filename has no extension */
function getFileExtension(filename) {
  const parts = filename.split('.');
  if (parts.length === 1) {
    return '';
  }
  return '.' + parts.pop();
}
function isMaxFileNumberValid(numFile, max) {
  return !numFile || !max || numFile <= max;
}
/**
 * Provides a set of file uploader validators that can be used by form controls.
 *
 * Currently `maxFileSize` and `fileType` are available.
 * @dynamic
 */
class NxFileUploaderValidators {
  /** The form control validator for the max file size. */
  static maxFileSize(max, file) {
    return control => {
      if (!max || max > file.size) {
        return null;
      }
      return {
        NxFileUploadMaxFileSize: {
          max,
          fileName: file.name,
          actual: file.size
        }
      };
    };
  }
  /** The form control validator for the accepted file type. */
  static fileType(file, accept, strict) {
    return control => {
      if (isFileTypeValid(file, accept, strict)) {
        return null;
      }
      return {
        NxFileUploadFileTypeNotAccepted: {
          fileName: file.name
        }
      };
    };
  }
  /** The form control validator for the max file number that is accepted. */
  static maxFileNumber(filesNum, max) {
    return control => {
      if (isMaxFileNumberValid(filesNum, max)) {
        return null;
      }
      return {
        NxFileUploadMaxFileNumber: {
          max,
          actual: filesNum
        }
      };
    };
  }
}

// This Directive solely purpose is to mark given ng-content and project it into the required destination.
class NxFileUploaderButtonDirective {
  /** Whether the file uploader is disabled */
  set disabled(value) {
    this._disabled = value;
    this._cdr.markForCheck();
  }
  get disabled() {
    return this._disabled;
  }
  constructor(_cdr, elemetRef) {
    this._cdr = _cdr;
    this.elemetRef = elemetRef;
    this._disabled = false;
    this._clicked = new Subject();
  }
  /** @docs-private */
  setDescribedByIds(ids) {
    this._ariaDescribedby = ids.join(' ');
  }
  /** @docs-private */
  onClick() {
    this._clicked.next();
  }
  ngOnDestroy() {
    this._clicked.complete();
  }
  static {
    this.ɵfac = function NxFileUploaderButtonDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NxFileUploaderButtonDirective)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: NxFileUploaderButtonDirective,
      selectors: [["", "nxFileUploadButton", ""]],
      hostVars: 4,
      hostBindings: function NxFileUploaderButtonDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function NxFileUploaderButtonDirective_click_HostBindingHandler() {
            return ctx.onClick();
          });
        }
        if (rf & 2) {
          i0.ɵɵattribute("aria-describedby", ctx._ariaDescribedby || null)("disabled", ctx.disabled || null);
          i0.ɵɵclassProp("nx-file-upload-button", true);
        }
      },
      inputs: {
        disabled: "disabled"
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NxFileUploaderButtonDirective, [{
    type: Directive,
    args: [{
      selector: '[nxFileUploadButton]',
      host: {
        '[attr.aria-describedby]': '_ariaDescribedby || null',
        '[attr.disabled]': 'disabled || null',
        '[class.nx-file-upload-button]': 'true'
      },
      standalone: true
    }]
  }], () => [{
    type: i0.ChangeDetectorRef
  }, {
    type: i0.ElementRef
  }], {
    disabled: [{
      type: Input
    }],
    onClick: [{
      type: HostListener,
      args: ['click']
    }]
  });
})();
function exists(item) {
  return item != null;
}
class NxFileUploaderDropZoneComponent {
  /** Whether the file uploader is disabled. */
  set disabled(value) {
    this._disabled = value;
    this._cdr.markForCheck();
  }
  get disabled() {
    return this._disabled;
  }
  constructor(_cdr) {
    this._cdr = _cdr;
    this._disabled = false;
    // flag when the drop zone is hovered
    this._active = false;
    /** An event emitted when files were dropped. */
    this.fileDropped = new EventEmitter();
  }
  /** @docs-private */
  onDrop(event) {
    event.preventDefault();
    if (this.disabled) {
      if (!event.dataTransfer) {
        return;
      }
      event.dataTransfer.dropEffect = 'no-drop'; // TODO wrog type: why do we do this? can we skip this?
    } else {
      if (!event.dataTransfer) {
        this.fileDropped.emit([]); // TODO shall we still emit if no data was transfered?
        return;
      }
      const {
        dataTransfer
      } = event;
      if (dataTransfer.items) {
        const files = Array.from(dataTransfer.items).map(item => item.getAsFile()).filter(exists);
        dataTransfer.items.clear();
        this.fileDropped.emit(files);
      } else {
        const files = Array.from(dataTransfer.files);
        dataTransfer.clearData();
        this.fileDropped.emit(files);
      }
      this._active = false;
    }
  }
  /** @docs-private */
  onDragOver(event) {
    event.stopPropagation();
    event.preventDefault();
    if (this.disabled) {
      event.dataTransfer.dropEffect = 'none';
    } else {
      event.dataTransfer.dropEffect = 'copy';
      this._active = true;
      this._cdr.markForCheck();
    }
  }
  /** @docs-private */
  onDragLeave(event) {
    this._active = false;
    event.dataTransfer.dropEffect = 'none';
    this._cdr.markForCheck();
  }
  /** @docs-private */
  onDragEnd(event) {
    event.dataTransfer.dropEffect = 'none';
  }
  /** @docs-private */
  onDragStart(event) {
    if (this.disabled) {
      event.dataTransfer.dropEffect = 'none';
    } else {
      event.dataTransfer.dropEffect = 'copy';
    }
  }
  /** @docs-private */
  get active() {
    return this._active;
  }
  static {
    this.ɵfac = function NxFileUploaderDropZoneComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NxFileUploaderDropZoneComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NxFileUploaderDropZoneComponent,
      selectors: [["nx-file-uploader-drop-zone"]],
      hostVars: 4,
      hostBindings: function NxFileUploaderDropZoneComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("drop", function NxFileUploaderDropZoneComponent_drop_HostBindingHandler($event) {
            return ctx.onDrop($event);
          })("dragover", function NxFileUploaderDropZoneComponent_dragover_HostBindingHandler($event) {
            return ctx.onDragOver($event);
          })("dragleave", function NxFileUploaderDropZoneComponent_dragleave_HostBindingHandler($event) {
            return ctx.onDragLeave($event);
          })("dragend", function NxFileUploaderDropZoneComponent_dragend_HostBindingHandler($event) {
            return ctx.onDragEnd($event);
          })("dragstart", function NxFileUploaderDropZoneComponent_dragstart_HostBindingHandler($event) {
            return ctx.onDragStart($event);
          });
        }
        if (rf & 2) {
          i0.ɵɵclassProp("is-active", ctx.active)("is-disabled", ctx.disabled);
        }
      },
      inputs: {
        disabled: "disabled"
      },
      outputs: {
        fileDropped: "fileDropped"
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function NxFileUploaderDropZoneComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      styles: ["[_nghost-%COMP%]     button{margin-bottom:16px}@media (min-width: 704px){[_nghost-%COMP%]{height:104px;border:1px dashed var(--file-uploader-drop-zone-border-color);align-items:center;justify-content:center;display:flex;color:var(--file-uploader-drop-zone-text-color)}.is-active[_nghost-%COMP%]{border-style:solid}.is-disabled[_nghost-%COMP%]{cursor:no-drop}[_nghost-%COMP%]     button{margin-bottom:0}}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NxFileUploaderDropZoneComponent, [{
    type: Component,
    args: [{
      selector: 'nx-file-uploader-drop-zone',
      changeDetection: ChangeDetectionStrategy.OnPush,
      host: {
        '[class.is-active]': 'active',
        '[class.is-disabled]': 'disabled'
      },
      standalone: true,
      template: "<ng-content></ng-content>\n",
      styles: [":host ::ng-deep button{margin-bottom:16px}@media (min-width: 704px){:host{height:104px;border:1px dashed var(--file-uploader-drop-zone-border-color);align-items:center;justify-content:center;display:flex;color:var(--file-uploader-drop-zone-text-color)}:host.is-active{border-style:solid}:host.is-disabled{cursor:no-drop}:host ::ng-deep button{margin-bottom:0}}\n"]
    }]
  }], () => [{
    type: i0.ChangeDetectorRef
  }], {
    disabled: [{
      type: Input
    }],
    fileDropped: [{
      type: Output
    }],
    onDrop: [{
      type: HostListener,
      args: ['drop', ['$event']]
    }],
    onDragOver: [{
      type: HostListener,
      args: ['dragover', ['$event']]
    }],
    onDragLeave: [{
      type: HostListener,
      args: ['dragleave', ['$event']]
    }],
    onDragEnd: [{
      type: HostListener,
      args: ['dragend', ['$event']]
    }],
    onDragStart: [{
      type: HostListener,
      args: ['dragstart', ['$event']]
    }]
  });
})();
let nextId$1 = 0;
// This Directive solely purpose is to mark given ng-content and project it into the required destination.
class NxFileUploaderHintDirective {
  constructor() {
    /** Sets the id of the file upload hint. */
    this.id = `nx-formfield-hint-${nextId$1++}`;
  }
  static {
    this.ɵfac = function NxFileUploaderHintDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NxFileUploaderHintDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: NxFileUploaderHintDirective,
      selectors: [["", "nxFileUploadHint", ""]],
      hostVars: 3,
      hostBindings: function NxFileUploaderHintDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("id", ctx.id);
          i0.ɵɵclassProp("nx-file-upload-hint", true);
        }
      },
      inputs: {
        id: "id"
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NxFileUploaderHintDirective, [{
    type: Directive,
    args: [{
      selector: '[nxFileUploadHint]',
      host: {
        '[attr.id]': 'id',
        '[class.nx-file-upload-hint]': 'true'
      },
      standalone: true
    }]
  }], null, {
    id: [{
      type: Input
    }]
  });
})();

/** Shows a delete button. */
class NxFileUploaderItemDelete {
  static {
    this.ɵfac = function NxFileUploaderItemDelete_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NxFileUploaderItemDelete)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NxFileUploaderItemDelete,
      selectors: [["nx-file-upload-delete"]],
      inputs: {
        isUploading: "isUploading",
        deleteLabel: "deleteLabel"
      },
      decls: 2,
      vars: 3,
      consts: [["nxIconButton", "tertiary small-medium", "type", "button"], ["name", "trash-o"]],
      template: function NxFileUploaderItemDelete_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "button", 0);
          i0.ɵɵelement(1, "nx-icon", 1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵattribute("aria-label", ctx.deleteLabel || null)("disabled", ctx.isUploading || null);
          i0.ɵɵadvance();
          i0.ɵɵattribute("aria-hidden", true);
        }
      },
      dependencies: [NxButtonModule, i1.NxIconButtonComponent, NxIconModule, i2.NxIconComponent],
      styles: ["[_nghost-%COMP%]{display:block}[_nghost-%COMP%] > button[_ngcontent-%COMP%]{margin-bottom:0;white-space:nowrap}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NxFileUploaderItemDelete, [{
    type: Component,
    args: [{
      selector: 'nx-file-upload-delete',
      template: `
        <button nxIconButton="tertiary small-medium" [attr.aria-label]="deleteLabel || null" type="button" [attr.disabled]="isUploading || null">
            <nx-icon name="trash-o" [attr.aria-hidden]="true"></nx-icon>
        </button>
    `,
      imports: [NxButtonModule, NxIconModule],
      styles: [":host{display:block}:host>button{margin-bottom:0;white-space:nowrap}\n"]
    }]
  }], null, {
    isUploading: [{
      type: Input
    }],
    deleteLabel: [{
      type: Input
    }]
  });
})();

/** Shows the file name. */
class NxFileUploaderItemName {
  constructor() {
    this.iconColor = {
      xls: '#1E8927',
      xlsx: '#1E8927',
      pdf: '#DC3149',
      png: '#ba31dc'
    };
  }
  ngOnInit() {
    this.extension = getFileExtension(this.name).substring(1);
  }
  static {
    this.ɵfac = function NxFileUploaderItemName_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NxFileUploaderItemName)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NxFileUploaderItemName,
      selectors: [["nx-file-upload-name"]],
      inputs: {
        name: "name"
      },
      decls: 5,
      vars: 2,
      consts: [[1, "extension"], [1, "extension-label", 3, "background-color"], ["name", "file", 1, "extension-icon"], [1, "nx-margin-left-2xs"], [1, "extension-label"]],
      template: function NxFileUploaderItemName_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "span", 0);
          i0.ɵɵtemplate(1, NxFileUploaderItemName_Conditional_1_Template, 2, 3, "span", 1);
          i0.ɵɵelement(2, "nx-icon", 2);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(3, "span", 3);
          i0.ɵɵtext(4);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.extension ? 1 : -1);
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate(ctx.name);
        }
      },
      dependencies: [NxIconModule, i2.NxIconComponent],
      styles: ["[_nghost-%COMP%]{font-size:var(--file-uploader-file-name-font-size);line-height:var(--file-uploader-file-name-line-height);font-weight:var(--file-uploader-file-name-font-weight);letter-spacing:var(--file-uploader-file-name-letter-spacing)}.extension[_ngcontent-%COMP%]{position:relative;top:4px;display:inline-flex}.extension-icon[_ngcontent-%COMP%]{font-size:1.375rem}.extension-label[_ngcontent-%COMP%]{position:absolute;text-transform:uppercase;-webkit-user-select:none;user-select:none;line-height:normal;font-weight:700;padding:1px 3px;right:4px;bottom:4px;border-radius:2px 0 0 2px;font-size:.375rem;color:#fff}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NxFileUploaderItemName, [{
    type: Component,
    args: [{
      selector: 'nx-file-upload-name',
      template: `
        <span class="extension">
            @if (extension) {
                <span class="extension-label" [style.background-color]="iconColor[extension] || '#000'">{{ extension }}</span>
            }
            <nx-icon name="file" class="extension-icon"></nx-icon>
        </span>
        <span class="nx-margin-left-2xs">{{ name }}</span>
    `,
      imports: [NxIconModule],
      styles: [":host{font-size:var(--file-uploader-file-name-font-size);line-height:var(--file-uploader-file-name-line-height);font-weight:var(--file-uploader-file-name-font-weight);letter-spacing:var(--file-uploader-file-name-letter-spacing)}.extension{position:relative;top:4px;display:inline-flex}.extension-icon{font-size:1.375rem}.extension-label{position:absolute;text-transform:uppercase;-webkit-user-select:none;user-select:none;line-height:normal;font-weight:700;padding:1px 3px;right:4px;bottom:4px;border-radius:2px 0 0 2px;font-size:.375rem;color:#fff}\n"]
    }]
  }], null, {
    name: [{
      type: Input
    }]
  });
})();

/** Shows a file size in Megabyte (MB) or an alternative label while the file is uploading. */
class NxFileUploaderItemSize {
  static {
    this.ɵfac = function NxFileUploaderItemSize_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NxFileUploaderItemSize)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NxFileUploaderItemSize,
      selectors: [["nx-file-upload-size"]],
      inputs: {
        size: "size",
        isUploading: "isUploading",
        uploadingLabel: "uploadingLabel"
      },
      decls: 2,
      vars: 1,
      template: function NxFileUploaderItemSize_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, NxFileUploaderItemSize_Conditional_0_Template, 2, 1, "span")(1, NxFileUploaderItemSize_Conditional_1_Template, 3, 4, "span");
        }
        if (rf & 2) {
          i0.ɵɵconditional(ctx.isUploading ? 0 : 1);
        }
      },
      dependencies: [DecimalPipe],
      styles: ["[_nghost-%COMP%]{white-space:nowrap}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NxFileUploaderItemSize, [{
    type: Component,
    args: [{
      selector: 'nx-file-upload-size',
      template: `
        @if (isUploading) {
            <span>{{ uploadingLabel }}</span>
        } @else {
            <span>{{ size / 1024 / 1024 | number: '.2' }} MB</span>
        }
    `,
      imports: [DecimalPipe],
      styles: [":host{white-space:nowrap}\n"]
    }]
  }], null, {
    size: [{
      type: Input
    }],
    isUploading: [{
      type: Input
    }],
    uploadingLabel: [{
      type: Input
    }]
  });
})();

/** Shows the current uploading status of a file. */
class NxFileUploaderItemStatus {
  static {
    this.ɵfac = function NxFileUploaderItemStatus_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NxFileUploaderItemStatus)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NxFileUploaderItemStatus,
      selectors: [["nx-file-upload-status"]],
      inputs: {
        isUploading: "isUploading",
        isUploaded: "isUploaded",
        uploadedLabel: "uploadedLabel"
      },
      decls: 2,
      vars: 2,
      consts: [["size", "medium"], ["name", "check-circle", "size", "s"]],
      template: function NxFileUploaderItemStatus_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, NxFileUploaderItemStatus_Conditional_0_Template, 1, 0, "nx-spinner", 0)(1, NxFileUploaderItemStatus_Conditional_1_Template, 1, 1, "nx-icon", 1);
        }
        if (rf & 2) {
          i0.ɵɵconditional(ctx.isUploading ? 0 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.isUploaded ? 1 : -1);
        }
      },
      dependencies: [NxSpinnerModule, i1$1.NxSpinnerComponent, NxIconModule, i2.NxIconComponent],
      styles: ["[_nghost-%COMP%]{display:flex}[_nghost-%COMP%]   nx-icon[_ngcontent-%COMP%]{color:var(--file-uploader-file-row-icon-color)}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NxFileUploaderItemStatus, [{
    type: Component,
    args: [{
      selector: 'nx-file-upload-status',
      template: `
        @if (isUploading) {
            <nx-spinner size="medium"></nx-spinner>
        }
        @if (isUploaded) {
            <nx-icon name="check-circle" size="s" [attr.aria-label]="uploadedLabel || null"> </nx-icon>
        }
    `,
      imports: [NxSpinnerModule, NxIconModule],
      styles: [":host{display:flex}:host nx-icon{color:var(--file-uploader-file-row-icon-color)}\n"]
    }]
  }], null, {
    isUploading: [{
      type: Input
    }],
    isUploaded: [{
      type: Input
    }],
    uploadedLabel: [{
      type: Input
    }]
  });
})();

/** File uploader data that requires internationalization. */
class NxFileUploaderIntl {
  constructor() {
    /**
     * Stream that emits whenever the labels here are changed. Use this to notify
     * components if the labels have changed after initialization.
     */
    this.changes = new Subject();
    /** A label for the uploading state used in the queue. */
    this.uploadingLabel = 'uploading';
    /** Aria-label for the delete icon. */
    this.deleteLabel = 'Delete';
    /** Aria-label for the 'successfully-uploaded' icon. */
    this.uploadedStateLabel = 'uploaded';
    /** Aria-label for the uploaded files list. */
    this.uploadedListLabel = 'List of uploaded files';
  }
  static {
    this.ɵfac = function NxFileUploaderIntl_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NxFileUploaderIntl)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: NxFileUploaderIntl,
      factory: NxFileUploaderIntl.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NxFileUploaderIntl, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();
let nextId = 0;
class NxFileUploaderComponent {
  /** Whether the file uploader use common validators (file type, file size). */
  set noBlockingValidators(value) {
    this._noBlockingValidators = coerceBooleanProperty(value);
  }
  get noBlockingValidators() {
    return this._noBlockingValidators;
  }
  /** Sets the id of the file uploader. */
  set id(value) {
    this._id = value;
    this._cdr.markForCheck();
  }
  get id() {
    return this._id;
  }
  /** Whether the file uploader is required. */
  set required(value) {
    this._required = coerceBooleanProperty(value);
  }
  get required() {
    return this._required;
  }
  /** The value of the file upload. */
  set value(value) {
    this.writeValue(value);
  }
  get value() {
    return this._value;
  }
  /** Name that is used for accessibility. */
  set name(value) {
    this._name = value;
  }
  get name() {
    return this._name;
  }
  /** Whether the file uploader is disabled. */
  set disabled(value) {
    this._disabled = coerceBooleanProperty(value);
    if (this.button) {
      this.button.disabled = this._disabled;
    }
    if (this._dropZone) {
      this._dropZone.disabled = this._disabled;
    }
    this._cdr.markForCheck();
  }
  get disabled() {
    return this._disabled;
  }
  /** Whether the file uploader accepts multiple files to be added. */
  set multiple(value) {
    this._multiple = coerceBooleanProperty(value);
  }
  get multiple() {
    return this._multiple;
  }
  /** The accepted file types */
  set accept(value) {
    this._accept = value;
  }
  get accept() {
    return this._accept;
  }
  /** The max file size in bytes used for validation */
  set maxFileSize(value) {
    this._maxFileSize = coerceNumberProperty(value);
  }
  get maxFileSize() {
    return this._maxFileSize;
  }
  /** Sets the file uploader for the component. */
  set uploader(newUploader) {
    if (this._uploader !== newUploader) {
      this._uploader = newUploader;
    }
  }
  get uploader() {
    return this._uploader;
  }
  /** The max number of files that is accepted. */
  set maxFileNumber(value) {
    this._maxFileNumber = coerceNumberProperty(value);
  }
  get maxFileNumber() {
    return this._maxFileNumber;
  }
  /** Sets the template for the file items. */
  set itemTemplate(template) {
    if (this._itemTemplate !== template) {
      this._itemTemplate = template;
    }
  }
  get itemTemplate() {
    return this._itemTemplate;
  }
  constructor(_cdr, _errorStateMatcher, _intl, _parentForm, _parentFormGroup, /** @docs-private */ngControl, _focusMonitor) {
    this._cdr = _cdr;
    this._errorStateMatcher = _errorStateMatcher;
    this._intl = _intl;
    this._parentForm = _parentForm;
    this._parentFormGroup = _parentFormGroup;
    this.ngControl = ngControl;
    this._focusMonitor = _focusMonitor;
    this._filesSubscriptions = [];
    /**
     * An event emitted when queue is changed.
     *
     * Emits the changed array of FileItems.
     * @docs-private
     */
    this.valueChange = new EventEmitter();
    /**
     * An event emitted when a file is deleted from the queue.
     *
     * Emits the deleted FileItem.
     */
    this.fileDeleted = new EventEmitter();
    /**
     * An event emitted when one or more files were added to the file input.
     *
     * Emits the selected `FileItem | FileItem[]`.
     */
    this.filesSelected = new EventEmitter();
    this._controlValidators = null;
    /** @docs-private */
    this.errorState = false;
    /** List of errors */
    this.errors = [];
    this._noBlockingValidators = false;
    /** @docs-private */
    this.stateChanges = new Subject();
    /** @docs-private */
    this.validatorFnArray = [];
    /** aria-describedby ids that will be applied to the inner controls */
    this.ariaDescribedBy = input();
    this._id = `nx-file-uploader-${nextId++}`;
    this._inputId = `${this.id}-input`;
    this._labelId = `${this.id}-label`;
    this._required = false;
    this._disabled = false;
    this._multiple = false;
    /** Whether to validate files that don't have provide a file type. Disabled by default. */
    this.strictAcceptValidation = false;
    this._maxFileSize = 0;
    this._maxFileNumber = null;
    this._destroyed = new Subject();
    /** Event emitted when the file picker dialog has been toggled. */
    this.openedChange = new EventEmitter();
    /** Event emitted when the file picker dialog has been opened. */
    this._openedStream = this.openedChange.pipe(filter(o => o), map(() => {}));
    /** Event emitted when the file picker dialog has been closed. */
    this._closedStream = this.openedChange.pipe(filter(o => !o), map(() => {}));
    /** @docs-private */
    this.onChangeCallback = _ => {};
    /** @docs-private */
    this.onTouchedCallback = () => {};
    if (this.ngControl) {
      // Note: we provide the value accessor through here, instead of
      // the `providers` to avoid running into a circular import.
      this.ngControl.valueAccessor = this;
    }
    this._templateContext = this;
  }
  ngOnInit() {
    if (this.ngControl?.control) {
      // we need to save the control validators.
      this._controlValidators = this.ngControl.control.validator;
    }
    this._intl.changes.pipe(takeUntil(this._destroyed)).subscribe(() => {
      this._cdr.markForCheck();
      this.stateChanges.next();
    });
    this._resetValidators();
  }
  ngAfterViewInit() {
    this._fileRowElements.forEach(row => this._focusMonitor.monitor(row));
    this._fileRowElementsPrevious = this._fileRowElements;
    this._fileRowElements.changes.pipe(takeUntil(this._destroyed)).subscribe(rowElements => {
      this._fileRowElementsPrevious.forEach(row => this._focusMonitor.stopMonitoring(row));
      this._fileRowElementsPrevious = rowElements;
      rowElements.forEach(row => this._focusMonitor.monitor(row));
    });
  }
  ngOnChanges() {
    this.stateChanges.next();
  }
  ngOnDestroy() {
    this._destroyed.next();
    this._destroyed.complete();
    this.stateChanges.complete();
    this._filesSubscriptions.forEach(subscription => subscription.unsubscribe());
    this._fileRowElements.forEach(row => this._focusMonitor.stopMonitoring(row));
  }
  /** @docs-private */
  updateErrorState() {
    const oldState = this.errorState;
    const parent = this._parentFormGroup || this._parentForm;
    const control = this.ngControl ? this.ngControl.control : null;
    const newState = this._errorStateMatcher.isErrorState(control, parent);
    if (newState !== oldState) {
      this.errorState = newState;
      this.stateChanges.next();
    }
  }
  registerOnChange(callback) {
    this.onChangeCallback = callback;
  }
  registerOnTouched(callback) {
    this.onTouchedCallback = callback;
  }
  writeValue(value) {
    if (this._value !== value) {
      if (value) {
        if (this._filesSubscriptions) {
          this._filesSubscriptions.forEach(fileSubscription => fileSubscription.unsubscribe());
          this._filesSubscriptions = [];
        }
      }
      this._value = value;
      this._subscribeToFileChanges();
    }
  }
  _resetValidators(clear = false) {
    if (this.ngControl?.control) {
      if (clear) {
        this.ngControl.control.clearValidators();
      }
      const validators = [];
      if (this._controlValidators) {
        validators.unshift(this._controlValidators);
      }
      if (this.validatorFnArray) {
        validators.push(...this.validatorFnArray);
      }
      this.ngControl.control.setValidators(validators);
      this.ngControl.control.updateValueAndValidity();
    }
  }
  ngAfterContentInit() {
    if (!this.button) {
      return;
    }
    this.button._clicked.pipe(takeUntil(this._destroyed)).subscribe(() => {
      this.errors = [];
      const reachMaxFileNumber = this.maxFileNumber && (this.value?.length || 0) === this.maxFileNumber;
      if (reachMaxFileNumber) {
        this.setMaxFileNumberError(this.maxFileNumber);
        this._resetValidators(true);
        return;
      }
      this.nativeInputFile.nativeElement.click();
    });
    const focusButton$ = fromEvent(this.button.elemetRef.nativeElement, 'focus');
    const clickButton$ = fromEvent(this.button.elemetRef.nativeElement, 'click');
    let opened = false;
    clickButton$.pipe(takeUntil(this._destroyed)).subscribe(() => {
      opened = true;
      this.openedChange.emit(opened);
    });
    focusButton$.pipe(takeUntil(this._destroyed)).subscribe(() => {
      // file picker dialog dont have closed event, so using combination of focus + opend to check instead.
      if (opened) {
        opened = false;
        this.openedChange.emit(opened);
      }
    });
    this.button.disabled = this.disabled;
    if (this._dropZone) {
      this._dropZone.fileDropped.pipe(takeUntil(this._destroyed)).subscribe(files => {
        this._addFilesToQueue(files);
      });
      this._dropZone.disabled = this.disabled;
    }
    if (this._label) {
      this._label.for = this._inputId;
      this._label.id = this._labelId;
    }
    this.stateChanges.pipe(takeUntil(this._destroyed)).subscribe(() => {
      this._syncDescribedByIds();
      this._cdr.markForCheck();
    });
    // Re-validate when the number of hints changes.
    this._hintChildren.changes.pipe(startWith(null), takeUntil(this._destroyed)).subscribe(() => {
      this._syncDescribedByIds();
      this._cdr.markForCheck();
    });
    // Re-validate when the number of hints changes.
    this._errorList.changes.pipe(startWith(null), takeUntil(this._destroyed)).subscribe(() => {
      this._syncDescribedByIds();
      this._cdr.markForCheck();
    });
  }
  _addFilesToQueue(files) {
    if (!this.multiple) {
      this.value = [];
    }
    this._setFileListFromValue(files);
    this._resetValidators(true);
    this.onChangeCallback(this.value);
    this.onTouchedCallback();
    this.valueChange.emit(this.value);
    this.filesSelected.emit(this.value);
  }
  _setFileListFromValue(files) {
    // we need to set max file size errors to false
    this.validatorFnArray = [];
    if (files === null) {
      this.value = undefined;
    } else {
      this.errors = [];
      const totalFilesNum = (this.value?.length || 0) + files.length;
      if (isMaxFileNumberValid(totalFilesNum, this.maxFileNumber)) {
        files.forEach(file => {
          if (!isMaxFileSizeValid(file, this.maxFileSize)) {
            this.setFileSizeError(file);
            return;
          }
          if (!isFileTypeValid(file, this.accept, this.strictAcceptValidation)) {
            this.setFileTypeError(file);
            return;
          }
          const newFile = new FileItem(file);
          if (this.value) {
            this.value.push(newFile);
          } else {
            this.value = [newFile];
          }
          this._cdr.markForCheck();
        });
      } else {
        this.setMaxFileNumberError(totalFilesNum);
      }
      this._subscribeToFileChanges();
    }
  }
  /** Removes a file from the value list of the file upload input. */
  removeFile(file) {
    this.value = this.value.filter(item => file !== item);
    if (this._filesSubscriptions) {
      this._filesSubscriptions.forEach(fileSubscription => fileSubscription.unsubscribe());
      this._filesSubscriptions = [];
    }
    this._subscribeToFileChanges();
    this.validatorFnArray = []; // bugfix: kick invalid type error on file remove
    this._resetValidators(true);
    this._cdr.markForCheck();
    this.valueChange.emit(this.value);
    this.fileDeleted.emit(file);
    this.onTouchedCallback();
    this.onChangeCallback(this.value);
    // resets the value of the file input, so that if a file is deleted and added again. otherwise there is no change detected
    this.nativeInputFile.nativeElement.value = '';
  }
  /** Uploads the files via the defined uploader. */
  uploadFiles() {
    if (!this.uploader) {
      console.warn('No uploader found. Please define a NxFileUpload to use the uploading mechanism.');
      return;
    }
    // Remove latest upload failed from the list
    if (this.uploader) {
      this.uploader.response.pipe(take(1)).subscribe(res => {
        const successFiles = this.value?.filter(file => file.isUploaded && !file.isError);
        const errorFiles = res.error?.files.filter(file => !file.isUploaded && file.isError);
        if (errorFiles?.length) {
          errorFiles?.forEach(file => this.setFileUploadError(file, 'An error occured while uploading'));
        }
        this.value = successFiles;
      });
      this.uploader.uploadFiles(this.value);
    }
  }
  ngDoCheck() {
    if (this.ngControl) {
      // We need to re-evaluate this on every change detection cycle, because there are some
      // error triggers that we can't subscribe to (e.g. parent form submissions). This means
      // that whatever logic is in here has to be super lean or we risk destroying the performance.
      this.updateErrorState();
    }
  }
  /**
   * The label for the uploading state used in the queue.
   * @docs-private
   */
  get uploadingLabel() {
    return this._intl.uploadingLabel;
  }
  /**
   * The label for the uploading state used in the queue.
   * @docs-private
   */
  get deleteLabel() {
    return this._intl.deleteLabel;
  }
  /**
   * The label for the uploading state used in the queue.
   * @docs-private
   */
  get uploadedLabel() {
    return this._intl.uploadedStateLabel;
  }
  /**
   * The label for the uploaded files in the queue.
   * @docs-private
   */
  get uploadedListLabel() {
    return this._intl.uploadedListLabel;
  }
  /**
   * Sets the list of element IDs that describe the child control. This allows the trigger element (button) to update
   * its `aria-describedby` attribute accordingly.
   */
  _syncDescribedByIds() {
    let ids = [];
    ids = this._hintChildren.map(hint => hint.id);
    ids = this._label ? [this._label.id, ...ids] : ids;
    ids = [...this._errorList.map(error => error.id), ...ids];
    ids = this.ariaDescribedBy() ? [...ids, this.ariaDescribedBy()] : ids;
    this.button?.setDescribedByIds(ids);
  }
  _handleKeydownListRow(event) {
    if (event.keyCode === DOWN_ARROW) {
      const nextFileItemRow = event.target.nextSibling;
      if (nextFileItemRow?.classList?.contains('nx-file-uploader--file-row')) {
        event.preventDefault();
        nextFileItemRow.focus();
      }
    } else if (event.keyCode === UP_ARROW) {
      const previousFileItemRow = event.target.previousSibling;
      if (previousFileItemRow?.classList?.contains('nx-file-uploader--file-row')) {
        event.preventDefault();
        previousFileItemRow.focus();
      }
    }
  }
  /**
   * Triggered when the `input[type=file]` is changed.
   */
  _onFileChange(event) {
    if (this.disabled) {
      return;
    }
    const target = event.target;
    const files = Array.from(target.files ?? []);
    this._addFilesToQueue(files);
    this.stateChanges.next();
    this._cdr.markForCheck();
    this.nativeInputFile.nativeElement.value = '';
  }
  /** Listens to changes in each file. */
  _subscribeToFileChanges() {
    if (this.value?.length) {
      let subscription;
      this.value.map(file => {
        subscription = file.onChange.subscribe(() => {
          this._cdr.markForCheck();
        });
        this._filesSubscriptions.push(subscription);
      });
    }
  }
  setMaxFileNumberError(totalFilesNum) {
    this.errors.push({
      filename: '',
      type: 'fileNumber',
      max: this.maxFileNumber,
      actual: totalFilesNum
    });
    if (!this.noBlockingValidators && this.ngControl?.control) {
      this.validatorFnArray.push(control => ({
        NxFileUploadMaxFileNumber: {
          max: this.maxFileNumber,
          actual: totalFilesNum
        }
      }));
    }
  }
  setFileSizeError(file) {
    this.errors.push({
      filename: file.name,
      type: 'fileSize',
      max: this.maxFileSize,
      actual: file.size
    });
    if (!this.noBlockingValidators && this.ngControl?.control) {
      this.validatorFnArray.push(NxFileUploaderValidators.maxFileSize(this.maxFileSize, file));
    }
  }
  setFileTypeError(file) {
    this.errors.push({
      filename: file.name,
      type: 'fileType',
      extension: this.accept,
      actual: getFileExtension(file.name)
    });
    if (!this.noBlockingValidators && this.ngControl?.control) {
      this.validatorFnArray.push(NxFileUploaderValidators.fileType(file, this.accept, this.strictAcceptValidation));
    }
  }
  setFileUploadError(file, reason) {
    this.errors.push({
      filename: file.name,
      type: 'upload',
      reason
    });
  }
  /** weather all files is uplaoded */
  get allFilesUploaded() {
    return this.value?.every(f => f.isUploaded) || false;
  }
  setDisabledState(isDisabled) {
    this.disabled = isDisabled;
    this.stateChanges.next();
  }
  static {
    this.ɵfac = function NxFileUploaderComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NxFileUploaderComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1$2.ErrorStateMatcher), i0.ɵɵdirectiveInject(NxFileUploaderIntl), i0.ɵɵdirectiveInject(i3.NgForm, 8), i0.ɵɵdirectiveInject(i3.FormGroupDirective, 8), i0.ɵɵdirectiveInject(i3.NgControl, 10), i0.ɵɵdirectiveInject(i4.FocusMonitor));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NxFileUploaderComponent,
      selectors: [["nx-file-uploader"]],
      contentQueries: function NxFileUploaderComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, NxFileUploaderButtonDirective, 5);
          i0.ɵɵcontentQuery(dirIndex, NxFileUploaderDropZoneComponent, 7);
          i0.ɵɵcontentQuery(dirIndex, NxLabelComponent, 5);
          i0.ɵɵcontentQuery(dirIndex, NxFileUploaderHintDirective, 4);
          i0.ɵɵcontentQuery(dirIndex, NxErrorComponent, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.button = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._dropZone = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._label = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._hintChildren = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._errorList = _t);
        }
      },
      viewQuery: function NxFileUploaderComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c1, 5);
          i0.ɵɵviewQuery(_c2, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.nativeInputFile = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._fileRowElements = _t);
        }
      },
      hostVars: 3,
      hostBindings: function NxFileUploaderComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("aria-invalid", ctx.errorState);
          i0.ɵɵclassProp("has-error", ctx.errorState);
        }
      },
      inputs: {
        noBlockingValidators: "noBlockingValidators",
        ariaDescribedBy: [1, "ariaDescribedBy"],
        id: "id",
        required: "required",
        value: "value",
        name: "name",
        disabled: "disabled",
        multiple: "multiple",
        accept: "accept",
        strictAcceptValidation: "strictAcceptValidation",
        maxFileSize: "maxFileSize",
        uploader: "uploader",
        maxFileNumber: "maxFileNumber",
        itemTemplate: "itemTemplate"
      },
      outputs: {
        valueChange: "valueChange",
        fileDeleted: "fileDeleted",
        filesSelected: "filesSelected",
        openedChange: "openedChange",
        _openedStream: "opened",
        _closedStream: "closed"
      },
      exportAs: ["NxFileUploaderComponent"],
      features: [i0.ɵɵProvidersFeature([{
        provide: ERROR_DEFAULT_OPTIONS,
        useValue: {
          appearance: 'message'
        }
      }]), i0.ɵɵNgOnChangesFeature],
      ngContentSelectors: _c4,
      decls: 11,
      vars: 6,
      consts: [["nativeInputFile", ""], ["defaultFileRow", ""], ["fileRowElement", ""], ["type", "file", 3, "change", "id"], ["role", "list", 1, "nx-file-uploader--file-list", "nx-margin-bottom-m"], ["role", "listitem", 1, "nx-file-uploader--file-row", 3, "nx-file-uploader--file-state-uploading", "nx-file-uploader--default-template"], ["role", "listitem", 1, "nx-file-uploader--file-row", 3, "keydown"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "name"], [3, "size", "isUploading", "uploadingLabel"], [1, "nx-file-uploader--file-row-actions"], [3, "isUploading", "isUploaded", "uploadedLabel"], [3, "click", "deleteLabel", "isUploading"]],
      template: function NxFileUploaderComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵprojectionDef(_c3);
          i0.ɵɵtemplate(0, NxFileUploaderComponent_Conditional_0_Template, 1, 0);
          i0.ɵɵprojection(1);
          i0.ɵɵprojection(2, 1);
          i0.ɵɵprojection(3, 2);
          i0.ɵɵprojection(4, 3);
          i0.ɵɵprojection(5, 4);
          i0.ɵɵelementStart(6, "input", 3, 0);
          i0.ɵɵlistener("change", function NxFileUploaderComponent_Template_input_change_6_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx._onFileChange($event));
          });
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(8, NxFileUploaderComponent_Conditional_8_Template, 3, 1, "div", 4)(9, NxFileUploaderComponent_ng_template_9_Template, 5, 9, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵconditional(ctx.errorState || ctx.errors.length ? 0 : -1);
          i0.ɵɵadvance(6);
          i0.ɵɵproperty("id", ctx._inputId);
          i0.ɵɵattribute("multiple", ctx.multiple || null)("disabled", ctx.disabled || null)("accept", ctx.accept);
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(ctx.value && ctx.value.length > 0 ? 8 : -1);
        }
      },
      dependencies: [NgTemplateOutlet, NxFileUploaderItemName, NxFileUploaderItemSize, NxFileUploaderItemStatus, NxFileUploaderItemDelete],
      styles: ["[_nghost-%COMP%]{display:block}[_nghost-%COMP%]     nx-error.nx-error--message{margin:12px 0}[_nghost-%COMP%]     nx-error.nx-error--message ul{margin-left:28px;margin-top:6px}[_nghost-%COMP%]     nx-error.nx-error--message li{line-height:24px}.nx-file-uploader--file-list[_ngcontent-%COMP%]{max-height:400px;overflow-y:auto}.nx-file-uploader--file-row[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap;align-items:center;border-bottom-width:1px;border-bottom-style:solid;padding:8px 12px;border-bottom-color:var(--file-uploader-file-row-border-bottom-color);color:var(--file-uploader-file-row-text-color)}.nx-file-uploader--file-row[_ngcontent-%COMP%]:hover{background-color:var(--file-uploader-file-row-hover-background-color)}.nx-file-uploader--file-row[_ngcontent-%COMP%]:focus{outline:none}.nx-file-uploader--file-row[_ngcontent-%COMP%]     .nx-file-uploader--file-row-actions{margin-left:auto;display:flex;align-items:center;justify-content:flex-end;min-width:120px;flex:none}[dir=rtl][_nghost-%COMP%]   .nx-file-uploader--file-row[_ngcontent-%COMP%]     .nx-file-uploader--file-row-actions, [dir=rtl]   [_nghost-%COMP%]   .nx-file-uploader--file-row[_ngcontent-%COMP%]     .nx-file-uploader--file-row-actions{margin-left:initial;margin-right:auto}.nx-file-uploader--file-row.nx-file-uploader--default-template[_ngcontent-%COMP%]   nx-file-upload-name[_ngcontent-%COMP%]{flex:none;max-width:65%;overflow-wrap:break-word;line-height:28px}@media (max-width: 703px){.nx-file-uploader--file-row.nx-file-uploader--default-template[_ngcontent-%COMP%]   nx-file-upload-name[_ngcontent-%COMP%]{flex:100%;max-width:100%}}.nx-file-uploader--file-row.nx-file-uploader--default-template[_ngcontent-%COMP%]   nx-file-upload-size[_ngcontent-%COMP%]{flex:1;display:flex;justify-content:flex-end}@media (max-width: 703px){.nx-file-uploader--file-row.nx-file-uploader--default-template[_ngcontent-%COMP%]   nx-file-upload-size[_ngcontent-%COMP%]{justify-content:flex-start}}.nx-file-uploader--file-row.nx-file-uploader--default-template[_ngcontent-%COMP%]   nx-file-upload-status[_ngcontent-%COMP%]{flex:0 1 auto;padding:0 16px}.nx-file-uploader--file-row.nx-file-uploader--default-template[_ngcontent-%COMP%]   nx-file-upload-delete[_ngcontent-%COMP%]{flex:0 1 auto}.nx-file-uploader--file-row.nx-file-uploader--file-state-uploading[_ngcontent-%COMP%]   .file-name[_ngcontent-%COMP%]{color:var(--file-uploader-file-row-uploading-file-name-color)}  input[type=file]{display:none}  .nx-file-upload-button{display:block}  .nx-file-upload-hint{font-size:var(--file-uploader-hint-font-size);line-height:var(--file-uploader-hint-line-height);font-weight:var(--file-uploader-hint-font-weight);letter-spacing:var(--file-uploader-hint-letter-spacing);display:block}.nx-file-uploader--file-row.cdk-keyboard-focused[_ngcontent-%COMP%]{box-shadow:var(--focus-box-shadow)}@media screen and (forced-colors: active),(forced-colors: active){.nx-file-uploader--file-row.cdk-keyboard-focused[_ngcontent-%COMP%]{box-shadow:0 0 0 2px background,0 0 0 6px CanvasText;outline:4px solid CanvasText;outline-offset:2px}}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NxFileUploaderComponent, [{
    type: Component,
    args: [{
      selector: 'nx-file-uploader',
      exportAs: 'NxFileUploaderComponent',
      changeDetection: ChangeDetectionStrategy.OnPush,
      host: {
        '[attr.aria-invalid]': 'errorState',
        '[class.has-error]': 'errorState'
      },
      providers: [{
        provide: ERROR_DEFAULT_OPTIONS,
        useValue: {
          appearance: 'message'
        }
      }],
      imports: [NgTemplateOutlet, NxFileUploaderItemName, NxFileUploaderItemSize, NxFileUploaderItemStatus, NxFileUploaderItemDelete],
      template: "@if (errorState || errors.length) {\n    <ng-content select=\"nx-error\"></ng-content>\n}\n\n<ng-content select=\"nx-label\"></ng-content>\n<ng-content select=\"[nxFileUploadHint]\"></ng-content>\n<ng-content></ng-content>\n<ng-content select=\"nx-file-uploader-drop-zone\"></ng-content>\n<ng-content select=\"[nxFileUploadButton]\"></ng-content>\n<input\n    #nativeInputFile\n    type=\"file\"\n    [attr.multiple]=\"multiple || null\"\n    [attr.disabled]=\"disabled || null\"\n    [attr.accept]=\"accept\"\n    (change)=\"_onFileChange($event)\"\n    [id]=\"_inputId\"\n/>\n@if (value && value.length > 0) {\n    <div class=\"nx-file-uploader--file-list nx-margin-bottom-m\" role=\"list\" [attr.aria-label]=\"_templateContext.uploadedListLabel\">\n        @for (file of value; track file) {\n            <div\n                #fileRowElement\n                class=\"nx-file-uploader--file-row\"\n                [class.nx-file-uploader--file-state-uploading]=\"file.isUploading\"\n                [class.nx-file-uploader--default-template]=\"!_itemTemplate\"\n                role=\"listitem\"\n                (keydown)=\"_handleKeydownListRow($event)\"\n            >\n                <ng-container\n                    *ngTemplateOutlet=\"_itemTemplate ? _itemTemplate : defaultFileRow; context: { templateContext: _templateContext, file: file }\"\n                ></ng-container>\n            </div>\n        }\n    </div>\n}\n\n<ng-template #defaultFileRow let-templateContext=\"templateContext\" let-file=\"file\">\n    <nx-file-upload-name [name]=\"file?.name\"></nx-file-upload-name>\n\n    <nx-file-upload-size [size]=\"file?.size\" [isUploading]=\"file.isUploading\" [uploadingLabel]=\"templateContext.uploadingLabel\"></nx-file-upload-size>\n\n    <div class=\"nx-file-uploader--file-row-actions\">\n        <nx-file-upload-status\n            [isUploading]=\"file.isUploading\"\n            [isUploaded]=\"file.isUploaded\"\n            [uploadedLabel]=\"templateContext.uploadedLabel\"\n        ></nx-file-upload-status>\n\n        <nx-file-upload-delete [deleteLabel]=\"templateContext.deleteLabel\" [isUploading]=\"file.isUploading\" (click)=\"removeFile(file)\"></nx-file-upload-delete>\n    </div>\n</ng-template>\n",
      styles: [":host{display:block}:host ::ng-deep nx-error.nx-error--message{margin:12px 0}:host ::ng-deep nx-error.nx-error--message ul{margin-left:28px;margin-top:6px}:host ::ng-deep nx-error.nx-error--message li{line-height:24px}.nx-file-uploader--file-list{max-height:400px;overflow-y:auto}.nx-file-uploader--file-row{display:flex;flex-wrap:wrap;align-items:center;border-bottom-width:1px;border-bottom-style:solid;padding:8px 12px;border-bottom-color:var(--file-uploader-file-row-border-bottom-color);color:var(--file-uploader-file-row-text-color)}.nx-file-uploader--file-row:hover{background-color:var(--file-uploader-file-row-hover-background-color)}.nx-file-uploader--file-row:focus{outline:none}.nx-file-uploader--file-row ::ng-deep .nx-file-uploader--file-row-actions{margin-left:auto;display:flex;align-items:center;justify-content:flex-end;min-width:120px;flex:none}:host-context([dir=rtl]) .nx-file-uploader--file-row ::ng-deep .nx-file-uploader--file-row-actions{margin-left:initial;margin-right:auto}.nx-file-uploader--file-row.nx-file-uploader--default-template nx-file-upload-name{flex:none;max-width:65%;overflow-wrap:break-word;line-height:28px}@media (max-width: 703px){.nx-file-uploader--file-row.nx-file-uploader--default-template nx-file-upload-name{flex:100%;max-width:100%}}.nx-file-uploader--file-row.nx-file-uploader--default-template nx-file-upload-size{flex:1;display:flex;justify-content:flex-end}@media (max-width: 703px){.nx-file-uploader--file-row.nx-file-uploader--default-template nx-file-upload-size{justify-content:flex-start}}.nx-file-uploader--file-row.nx-file-uploader--default-template nx-file-upload-status{flex:0 1 auto;padding:0 16px}.nx-file-uploader--file-row.nx-file-uploader--default-template nx-file-upload-delete{flex:0 1 auto}.nx-file-uploader--file-row.nx-file-uploader--file-state-uploading .file-name{color:var(--file-uploader-file-row-uploading-file-name-color)}::ng-deep input[type=file]{display:none}::ng-deep .nx-file-upload-button{display:block}::ng-deep .nx-file-upload-hint{font-size:var(--file-uploader-hint-font-size);line-height:var(--file-uploader-hint-line-height);font-weight:var(--file-uploader-hint-font-weight);letter-spacing:var(--file-uploader-hint-letter-spacing);display:block}.nx-file-uploader--file-row.cdk-keyboard-focused{box-shadow:var(--focus-box-shadow)}@media screen and (forced-colors: active),(forced-colors: active){.nx-file-uploader--file-row.cdk-keyboard-focused{box-shadow:0 0 0 2px background,0 0 0 6px CanvasText;outline:4px solid CanvasText;outline-offset:2px}}\n"]
    }]
  }], () => [{
    type: i0.ChangeDetectorRef
  }, {
    type: i1$2.ErrorStateMatcher
  }, {
    type: NxFileUploaderIntl
  }, {
    type: i3.NgForm,
    decorators: [{
      type: Optional
    }]
  }, {
    type: i3.FormGroupDirective,
    decorators: [{
      type: Optional
    }]
  }, {
    type: i3.NgControl,
    decorators: [{
      type: Optional
    }, {
      type: Self
    }]
  }, {
    type: i4.FocusMonitor
  }], {
    button: [{
      type: ContentChild,
      args: [NxFileUploaderButtonDirective, {
        static: false
      }]
    }],
    _dropZone: [{
      type: ContentChild,
      args: [NxFileUploaderDropZoneComponent, {
        static: true
      }]
    }],
    nativeInputFile: [{
      type: ViewChild,
      args: ['nativeInputFile', {
        static: false
      }]
    }],
    _label: [{
      type: ContentChild,
      args: [NxLabelComponent, {
        static: false
      }]
    }],
    _hintChildren: [{
      type: ContentChildren,
      args: [NxFileUploaderHintDirective]
    }],
    _errorList: [{
      type: ContentChildren,
      args: [NxErrorComponent]
    }],
    _fileRowElements: [{
      type: ViewChildren,
      args: ['fileRowElement']
    }],
    valueChange: [{
      type: Output
    }],
    fileDeleted: [{
      type: Output
    }],
    filesSelected: [{
      type: Output
    }],
    noBlockingValidators: [{
      type: Input
    }],
    id: [{
      type: Input
    }],
    required: [{
      type: Input
    }],
    value: [{
      type: Input
    }],
    name: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    multiple: [{
      type: Input
    }],
    accept: [{
      type: Input
    }],
    strictAcceptValidation: [{
      type: Input
    }],
    maxFileSize: [{
      type: Input
    }],
    uploader: [{
      type: Input
    }],
    maxFileNumber: [{
      type: Input
    }],
    itemTemplate: [{
      type: Input
    }],
    openedChange: [{
      type: Output
    }],
    _openedStream: [{
      type: Output,
      args: ['opened']
    }],
    _closedStream: [{
      type: Output,
      args: ['closed']
    }]
  });
})();

// This Directive solely purpose is to mark given ng-content and project it into the required destination.
class NxFileUploaderTriggerDirective {
  /** References the file upload component instance that the trigger is associated with. */
  set fileUpload(value) {
    if (this._fileUpload !== value) {
      this._fileUpload = value;
    }
  }
  get fileUpload() {
    return this._fileUpload;
  }
  _onClick() {
    this._fileUpload.uploadFiles();
  }
  get visibility() {
    return this._fileUpload.allFilesUploaded ? 'hidden' : 'unset';
  }
  static {
    this.ɵfac = function NxFileUploaderTriggerDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NxFileUploaderTriggerDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: NxFileUploaderTriggerDirective,
      selectors: [["", "nxFileUploadTriggerFor", ""]],
      hostVars: 2,
      hostBindings: function NxFileUploaderTriggerDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function NxFileUploaderTriggerDirective_click_HostBindingHandler() {
            return ctx._onClick();
          });
        }
        if (rf & 2) {
          i0.ɵɵstyleProp("visibility", ctx.visibility);
        }
      },
      inputs: {
        fileUpload: [0, "nxFileUploadTriggerFor", "fileUpload"]
      },
      exportAs: ["nxFileUploadTrigger"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NxFileUploaderTriggerDirective, [{
    type: Directive,
    args: [{
      selector: '[nxFileUploadTriggerFor]',
      exportAs: 'nxFileUploadTrigger',
      standalone: true
    }]
  }], null, {
    fileUpload: [{
      type: Input,
      args: ['nxFileUploadTriggerFor']
    }],
    _onClick: [{
      type: HostListener,
      args: ['click']
    }],
    visibility: [{
      type: HostBinding,
      args: ['style.visibility']
    }]
  });
})();
class NxFileUploaderModule {
  static {
    this.ɵfac = function NxFileUploaderModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NxFileUploaderModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: NxFileUploaderModule,
      imports: [CommonModule, NxIconModule, NxButtonModule, NxSpinnerModule, NxFileUploaderComponent, NxFileUploaderButtonDirective, NxFileUploaderHintDirective, NxFileUploaderDropZoneComponent, NxFileUploaderTriggerDirective, NxFileUploaderItemName, NxFileUploaderItemSize, NxFileUploaderItemStatus, NxFileUploaderItemDelete],
      exports: [NxFileUploaderComponent, NxFileUploaderButtonDirective, NxFileUploaderHintDirective, NxFileUploaderDropZoneComponent, NxErrorModule, NxLabelModule, NxFileUploaderTriggerDirective, NxFileUploaderItemName, NxFileUploaderItemSize, NxFileUploaderItemStatus, NxFileUploaderItemDelete]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, NxIconModule, NxButtonModule, NxSpinnerModule, NxFileUploaderComponent, NxFileUploaderItemName, NxFileUploaderItemStatus, NxFileUploaderItemDelete, NxErrorModule, NxLabelModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NxFileUploaderModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, NxIconModule, NxButtonModule, NxSpinnerModule, NxFileUploaderComponent, NxFileUploaderButtonDirective, NxFileUploaderHintDirective, NxFileUploaderDropZoneComponent, NxFileUploaderTriggerDirective, NxFileUploaderItemName, NxFileUploaderItemSize, NxFileUploaderItemStatus, NxFileUploaderItemDelete],
      exports: [NxFileUploaderComponent, NxFileUploaderButtonDirective, NxFileUploaderHintDirective, NxFileUploaderDropZoneComponent, NxErrorModule, NxLabelModule, NxFileUploaderTriggerDirective, NxFileUploaderItemName, NxFileUploaderItemSize, NxFileUploaderItemStatus, NxFileUploaderItemDelete]
    }]
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { FileItem, NxFileUploadError, NxFileUploadSuccess, NxFileUploader, NxFileUploaderButtonDirective, NxFileUploaderComponent, NxFileUploaderDropZoneComponent, NxFileUploaderHintDirective, NxFileUploaderIntl, NxFileUploaderItemDelete, NxFileUploaderItemName, NxFileUploaderItemSize, NxFileUploaderItemStatus, NxFileUploaderModule, NxFileUploaderTriggerDirective, NxFileUploaderValidators, getFileExtension, isFileTypeValid, isMaxFileNumberValid, isMaxFileSizeValid };
